import jsonStringifyPrettyCompact from 'json-stringify-pretty-compact';

export const stringify = (object: any) => jsonStringifyPrettyCompact(object, { maxLength: 120 });
export const formatJson = (json: string) => stringify(JSON.parse(json));
